import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {getDeviceBatchs} from "apollo/queries/getDeviceBatchs";
import {getDeviceBatch} from "apollo/queries/getDeviceBatch";
import {updateDeviceBatchMutation} from "apollo/mutations/updateDeviceBatch";
import {createDeviceBatchMutation} from "apollo/mutations/createDeviceBatch";
import {deleteDeviceBatchMutation} from "apollo/mutations/deleteDeviceBatch";
import {onboardDeviceBatchMutation} from "apollo/mutations/onboardDeviceBatch";
import {fetchDeviceBatchsSuccess, updateDeviceBatchSuccess,
createDeviceBatchSuccess, deleteDeviceBatchSuccess,
onboardDeviceBatchSuccess, fetchDeviceBatchSuccess} from "../actions/DeviceBatch";
import {fetchError} from "../actions/Common";
import {client} from "apollo/client";

import {
  CREATEDEVICEBATCH,
  UPDATEDEVICEBATCH,
  DELETEDEVICEBATCH,
  FETCHDEVICEBATCHS,
  FETCHDEVICEBATCH,
  ONBOARDDEVICEBATCH
} from "constants/ActionTypes";

const getDeviceBatchsRequest = async () => {
  try {
    let { data, error } = await client.query({
      query: getDeviceBatchs,
      variables: {
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const getDeviceBatchRequest = async (serial) => {
  try {
    let { data, error } = await client.query({
      query: getDeviceBatch,
      variables: {
        serial: serial
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createDeviceBatchRequest = async (input) => {
  console.log('input', input);
  let { data, error } = await client.mutate({
    mutation: createDeviceBatchMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const updateDeviceBatchRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: updateDeviceBatchMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const deleteDeviceBatchRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteDeviceBatchMutation,
      variables: {
        deviceBatchId: input
      }
    });

    console.log('data', data);

    if (data.deleteDeviceBatchById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Device batch not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const onboardDeviceBatchRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: onboardDeviceBatchMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

function* getDeviceBatchsCall({payload}) {
  console.log('getDeviceBatchsCall', payload);

  try {
    const fetched = yield call(getDeviceBatchsRequest);
    yield put(fetchDeviceBatchsSuccess(fetched));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* getDeviceBatchCall({payload}) {
  console.log('getDeviceBatchCall', payload);
  const { serial } = payload;

  try {
    const fetched = yield call(getDeviceBatchRequest, serial);
    yield put(fetchDeviceBatchSuccess(fetched));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* createDeviceBatchCall({payload}) {

  try {
    const {createDeviceBatch} = yield call(createDeviceBatchRequest, payload);
    yield put(createDeviceBatchSuccess(createDeviceBatch));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateDeviceBatchCall({payload}) {
  try {
    const {updateDeviceBatch} = yield call(updateDeviceBatchRequest, payload);
    yield put(updateDeviceBatchSuccess(updateDeviceBatch));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* onboardDeviceBatchCall({payload}) {
  try {
    const res = yield call(onboardDeviceBatchRequest, payload);
    yield put(onboardDeviceBatchSuccess(res.onboardDeviceBatch));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteDeviceBatchCall({payload}) {

  try {
    const deletedDeviceBatch = yield call(deleteDeviceBatchRequest, payload);
    yield put(deleteDeviceBatchSuccess(deletedDeviceBatch));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

export function* fetchDeviceBatchs() {
  yield takeEvery(FETCHDEVICEBATCHS, getDeviceBatchsCall);
}

export function* fetchDeviceBatch() {
  yield takeEvery(FETCHDEVICEBATCH, getDeviceBatchCall);
}

export function* updateDeviceBatch() {
  yield takeEvery(UPDATEDEVICEBATCH, updateDeviceBatchCall);
}

export function* createDeviceBatch() {
  yield takeEvery(CREATEDEVICEBATCH, createDeviceBatchCall);
}

export function* deleteDeviceBatch() {
  yield takeEvery(DELETEDEVICEBATCH, deleteDeviceBatchCall);
}

export function* onboardDeviceBatch() {
  yield takeEvery(ONBOARDDEVICEBATCH, onboardDeviceBatchCall);
}

export default function* rootSaga() {
  yield all([
  fork(updateDeviceBatch),
  fork(createDeviceBatch),
  fork(deleteDeviceBatch),
  fork(fetchDeviceBatchs),
  fork(fetchDeviceBatch),
  fork(onboardDeviceBatch)]);
}
